import { __assign } from "tslib";
import { memoizeFunction } from '@fluentui/react/lib/Utilities';
import { HighContrastSelector, FontSizes, mergeStyleSets } from '@fluentui/react/lib/Styling';
import { baseFabricFocusSelector, baseFabricHoverFocusSelector, getStandardControlSemanticColorsWithTheme, } from '@ms/app-commanding-ui';
import { commonHighContrastHoverFocusStyles, commonHighContrastOutlineHoverFocus, } from '@ms/app-commanding-ui/lib/styling';
export var getDocumentTitleCalloutLocationStyles = memoizeFunction(function (theme, colors) { return ({
    classNames: getClassNames(colors, theme),
}); });
export var getDocumentTitleCalloutToolTipStyles = memoizeFunction(function () {
    return { root: { display: 'inline-block' } };
});
export var getMoveButtonStyles = memoizeFunction(function (theme) {
    var _a;
    return {
        root: {
            cursor: 'pointer',
            selectors: (_a = {},
                _a[":focus, :hover, " + baseFabricHoverFocusSelector] = {
                    backgroundColor: getStandardControlSemanticColorsWithTheme(theme).hoverBackgroundColor,
                    commonHighContrastOutlineHoverFocus: commonHighContrastOutlineHoverFocus,
                    commonHighContrastHoverFocusStyles: commonHighContrastHoverFocusStyles,
                },
                _a),
        },
    };
});
export var controlDimensions = {
    breadcrumbHeight: 32,
    locationButtonHeight: 42,
    breadcrumbMaxWidth: 130,
    chevronHeight: 10,
    locationPaddingHeight: 20,
    locationSectionHeight: 61,
    titleSectionHeight: 70,
    versionHistoryHeight: 20,
    versionHistorySectionHeight: 53,
};
var getLinkStyle = function (colors) { return ({
    color: colors.primary,
    background: 'transparent',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    fontWeight: 'normal',
    fontSize: FontSizes.medium,
    textDecoration: 'none',
    cursor: 'pointer',
}); };
var getLinkSelectorStyle = function (colors) {
    var _a, _b, _c;
    return ({
        selectors: (_a = {
                ':hover, :active': {
                    color: colors.hoverBackground,
                    background: 'transparent',
                    selectors: (_b = {},
                        _b[HighContrastSelector] = {
                            color: 'highlight',
                        },
                        _b),
                }
            },
            _a[":focus, " + baseFabricFocusSelector] = {
                color: colors.hoverBackground,
                background: 'transparent',
                outline: colors.hoverBackground + " dashed 1px",
                selectors: (_c = {},
                    _c[HighContrastSelector] = {
                        color: 'highlight',
                    },
                    _c),
            },
            _a),
    });
};
var getClassNames = function (colors, theme) {
    var linkStyles = getLinkStyle(colors);
    var linkSelectorStyles = getLinkSelectorStyle(colors);
    var borderSemanticColor = getStandardControlSemanticColorsWithTheme(theme).borderColor;
    return mergeStyleSets({
        chevron: {
            display: 'flex',
            paddingTop: 1,
            fill: colors.defaultBackground,
            height: controlDimensions.chevronHeight,
            width: controlDimensions.chevronHeight,
            minWidth: controlDimensions.chevronHeight,
            lineHeight: controlDimensions.chevronHeight,
        },
        flexContainer: {
            display: 'flex',
        },
        documentTitleSection: {
            display: 'flex',
            flexDirection: 'column',
            height: controlDimensions.titleSectionHeight,
        },
        documentLocationSection: {
            display: 'flex',
            flexDirection: 'column',
        },
        sectionName: {
            display: 'block',
            paddingBottom: 10,
        },
        documentLocation: {
            display: 'inline-flex',
            alignItems: 'center',
            paddingLeft: '5px',
            paddingTop: controlDimensions.locationPaddingHeight,
            paddingBottom: controlDimensions.locationPaddingHeight,
            overflow: 'hidden',
            borderStyle: 'solid',
            borderWidth: '1px',
            borderColor: borderSemanticColor,
            zIndex: '1',
            width: '100%',
        },
        moveButton: {
            display: 'inline-flex',
            float: 'right',
            alignItems: 'center',
            overflow: 'hidden',
            paddingTop: controlDimensions.locationPaddingHeight,
            paddingBottom: controlDimensions.locationPaddingHeight,
            borderWidth: '1px',
            borderStyle: 'solid',
            zIndex: '10',
            marginLeft: 'auto',
            borderColor: borderSemanticColor,
            borderLeft: '0px',
        },
        moveButtonContainer: {
            paddingTop: controlDimensions.locationPaddingHeight,
            paddingBottom: controlDimensions.locationPaddingHeight,
            borderLeft: '0px',
        },
        keepOnRight: {
            marginLeft: 'auto',
        },
        folderIcon: {
            display: 'flex',
            height: 'auto',
            width: 'auto',
            maxHeight: controlDimensions.breadcrumbHeight,
        },
        breadcrumbContainer: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            height: controlDimensions.breadcrumbHeight,
            paddingLeft: '12px',
        },
        breadcrumbItem: __assign(__assign(__assign({}, linkStyles), linkSelectorStyles), { maxWidth: controlDimensions.breadcrumbMaxWidth, textDecoration: 'underline' }),
        locationChevron: {
            display: 'flex',
            maxHeight: controlDimensions.breadcrumbHeight,
            padding: '0 2px',
        },
        rowOrientation: {
            display: 'flex',
            flexDirection: 'row',
            maxHeight: controlDimensions.locationButtonHeight,
        },
    });
};
//# sourceMappingURL=DocumentTitleCalloutLocation.styles.js.map